import React from "react";
import { SetStateAction } from "react";

import { BlogsHeroCard } from "../../../../shadcn/components/custom/BlogsHeroCard";
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../../../../shadcn/components//ui/carousel";

interface BlogsData {
  date?: string;
  title?: string;
  description?: string;
  imageLink?: string;
  link?: string;
  category?: string;
}

interface props {
  title?: string;
  subtitle?: string;
  className?: string;
  headingClassName?: string;
  progress: number;
  blogsData?: BlogsData[];
  setProgress: React.Dispatch<SetStateAction<number>>;
}

export const BlogsHeroComponent = ({
  title,
  subtitle,
  progress,
  blogsData,
  className,
  headingClassName,
  setProgress,
}: props) => {
  return (
    <>
      {" "}
      <div
        className={` ${className} bg-[#FAF7FA] clip-path-bottomRightFooterMobile lg:clip-path-bottomRightTool`}
      >
        <div className="px-customPaddingMobile pb-11 pt-8 lg:pt-[72px] lg:pb-20 w-full justify-between lg:px-customPadding lg:flex  2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
          <div className="lg:max-w-[383px]">
            <p
              className={` ${headingClassName} font-spaceGrotesk text-brand-bgBlack lg:font-normal text-mobile-h2 leading-9 text-center lg:text-start lg:text-[66px] lg:leading-[84px]`}
            >
              {/* TRENDING BLOG */}
              {title}
            </p>
            <p className="font-openSans font-normal text-mobile-body-sm leading-4 lg:text-web-subheading text-brand-textLightGrey text-center lg:text-start lg:leading-6 mt-1 lg:mt-6">
              {/* Tips for Successful Bidding and Acquiring Properties */}
              {subtitle}
            </p>

            {/* Custom Progress Bar */}
            <ul className="lg:flex mt-16 hidden  gap-4 left-1/3">
              <li
                className={`w-[50px] lg:w-[65px] h-1 ${
                  progress <= 0.25 ? "bg-brand-textBlack" : "bg-[#EEEEEE]"
                }`}
              />
              <li
                className={`w-[50px] lg:w-[65px] h-1 ${
                  progress <= 0.5 && progress >= 0.25
                    ? "bg-brand-textBlack"
                    : "bg-[#EEEEEE]"
                }`}
              />
              <li
                className={`w-[50px] lg:w-[65px] h-1 ${
                  progress >= 0.5 && progress <= 0.75
                    ? "bg-brand-textBlack"
                    : "bg-[#EEEEEE]"
                }`}
              />{" "}
              <li
                className={`w-[50px] lg:w-[65px] h-1 ${
                  progress >= 0.75 ? "bg-brand-textBlack" : "bg-[#EEEEEE]"
                }`}
              />
            </ul>
          </div>
          <Carousel
            plugins={[
              Autoplay({
                delay: 2000,
              }),
            ]}
            onProgressChange={setProgress}
            className="w-full mt-5 lg:mt-0  lg:max-w-[500px] mid:max-w-[700px] lg:ml-auto lg:pl-4"
          >
            <CarouselContent>
              {blogsData?.slice(0, 4)?.map((card, index) => (
                <CarouselItem key={index}>
                  <div className="">
                    <BlogsHeroCard
                      tag={card?.category}
                      blogLink={card?.link}
                      imageLink={card?.imageLink}
                      textContent={card?.description}
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
          {/* Custom Progress Bar Mobile Screen*/}
          <ul className="lg:hidden justify-center mt-[28px] flex  gap-4 left-1/3">
            <li
              className={`w-[50px] lg:w-[65px] h-1 ${
                progress <= 0.25 ? "bg-brand-textBlack" : "bg-[#EEEEEE]"
              }`}
            />
            <li
              className={`w-[50px] lg:w-[65px] h-1 ${
                progress <= 0.5 && progress >= 0.25
                  ? "bg-brand-textBlack"
                  : "bg-[#EEEEEE]"
              }`}
            />
            <li
              className={`w-[50px] lg:w-[65px] h-1 ${
                progress >= 0.5 && progress <= 0.75
                  ? "bg-brand-textBlack"
                  : "bg-[#EEEEEE]"
              }`}
            />{" "}
            <li
              className={`w-[50px] lg:w-[65px] h-1 ${
                progress >= 0.75 ? "bg-brand-textBlack" : "bg-[#EEEEEE]"
              }`}
            />
          </ul>
        </div>
      </div>
    </>
  );
};

export default BlogsHeroComponent;
